import Title from '@zenbusiness/common-components/Title';
import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';
import makeStyles from '@mui/styles/makeStyles';

import SharedAsset from '../SharedAsset';

import miscMapBackground from '../../images/miscmap.png';

const useStyles = makeStyles((theme) => ({
  root: {},
  privacyCtaContainer: {
    minHeight: '140px',
    width: '100%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `url(${miscMapBackground})`,
    borderRadius: '5px'
  },
  privacyCtaBubble: {
    background: '#363636',
    padding: '10px 15px',
    position: 'relative',
    textAlign: 'center',
    verticalAlign: 'top',
    borderRadius: '5px',
    margin: '1em',
    overflow: 'hidden',
    textTransform: 'uppercase'
  },
  privacyCtaContent: {
    margin: 'auto',
    textAlign: 'center',
    color: '#FFF',
    fontStyle: 'normal',
    lineHeight: '20px'
  },
  addressTitle: {
    textTransform: 'none'
  },
  icon: {
    marginLeft: 5,
    width: 16,
    height: 16
  },
  shield: {
    fill: theme.palette.primary.light,
    stroke: theme.palette.primary.light
  }
}));

const PrivacyMap = (props) => {
  const classes = useStyles();
  const { contact, domainPrivacy, containerOverrideStyles } = props;

  const showAddress = (contactInfo) => {
    if (contactInfo) {
      return (
        <>
          {`${contactInfo.firstName} ${contactInfo.lastName}`}
          <br />
          {contactInfo.address1}
          <br />
          {contactInfo.address2 && (
            <>
              {contactInfo.address2}
              <br />
            </>
          )}
          {`${contactInfo.city}, ${contactInfo.state}, ${contactInfo.zipCode}`}
        </>
      );
    }
    return <>YOUR ADDRESS HERE</>;
  };

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      className={`${classes.privacyCtaContainer} ${containerOverrideStyles}`}
    >
      {domainPrivacy ? (
        <>
          <Grid item className={`${classes.privacyCtaBubble} ${classes.flexContainer}`}>
            <Title color="focus00" variant="sm-bold" level={5} className={classes.addressTitle}>Address Protected</Title>
            <SharedAsset src="/icon/micro/shield.svg" alt="shield" width={18} className={`${classes.icon} ${classes.shield}`} />
          </Grid>
        </>
      ) : (
        <Grid item className={classes.privacyCtaBubble}>
          <SharedAsset src="/icon/micro/property-location.svg" width={18} alt="location" />
          <Title color="focus00" variant="sm-bold" level={5}>
            {showAddress(contact)}
          </Title>
        </Grid>
      )}
    </Grid>
  );
};

PrivacyMap.propTypes = {
  domainPrivacy: PropTypes.bool,
  contact: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    address1: PropTypes.string.isRequired,
    address2: PropTypes.string,
    city: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    zipCode: PropTypes.string.isRequired
  }),
  containerOverrideStyles: PropTypes.string
};

PrivacyMap.defaultProps = {
  domainPrivacy: false,
  contact: null,
  containerOverrideStyles: ''
};

export default PrivacyMap;
